import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import moment from "moment";
import Select from "react-select";
import Rodal from "rodal";
import * as jsPDF from "jspdf";
import {
  main_url,
  getUserId,
  getMainRole,
  getInformation,
  print,
  fno,
} from "../../../../utils/CommonFunction";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class BenefitChildTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: getUserId("user_info"),
      dataSource: props.data,
      selectedRequest: "",
      is_main_role: getMainRole(),
      view_data: null,
      visible: true,
      isCheckAllBox: false,
    };
  }

  componentDidMount() {
    this.setState(
      {
        dataSource: this.props.data,
      },
      () => {
        this._setTableData(this.state.dataSource);
      }
    );
    this.$el = $(this.el);
    let that = this;
    $("#dataTables-table").on("click", "#toView", function () {
      // var data = $(this).find("#view").text();
      // data = $.parseJSON(data);
      // that.props.goToViewForm(data);
      var data = $(this).find("#view").text();
      data = $.parseJSON(data);
      //   that.setState({
      //     view_data:data
      //   })

      that.props.goToViewForm(data);
    });

    // $("#dataTables-table").on('click', '#toPrint', function () {

    //     fetch(`${main_url}child_benefit/getChildAvailableAmount`, {
    //   headers: getHeaders(),
    // })
    //         .then(res => { if (res.ok) return res.json() })
    //         .then(list => {
    //             var data = $(this).find("#print").text();
    //             data = $.parseJSON(data);

    //             that.getPrintData(data, list.amount)
    //         })

    // });

    $("#dataTables-table").on("click", "#toEdit", function () {
      var data = $(this).find("#edit").text();
      var tempdata = $.parseJSON(data);

      // that.props.goToEditForm(data);
    });
    $("#dataTables-table").on("click", "#toSelect", function () {
      var data = $(this).find("#select").text();
      data = $.parseJSON(data);
      that.props.handleCheckBoxChange(data);
    });
  }

  componentDidUpdate(prevProps) {
    console.log(
      "Here is update now >>>>>>>>>>>>>>>>>>>>>>>ssssss",
      this.props.checkboxAll
    );

    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          dataSource: this.props.data,
          prevProps: prevProps,
        },
        async () => {
          await this._setTableData(this.state.dataSource);
          $("#dropdownid").on("change", function (e) {});
          // $("#checkPerson").on('click', function (e) {

          //     // var data = $(this).find("#checkPerson").text();
          //     // var data1 = $('#dropdownid').val("Hello");
          //     console.log('data is =================>',  $(this).val())
          //     // data = $.parseJSON(data);

          //     // that.props.handleCheckBoxChange(data);

          // });
        }
      );
    }

    if (this.props.checkboxAll != prevProps.checkboxAll) {
      /////            this.state.dataSource;
      if (this.props.checkboxAll) {
        // $(".ipSelect").prop("checked", true);

        //datatable has to be initialized to a variable
        var myTable = $("#dataTables-table").dataTable();
        //checkboxes should have a general class to traverse
        myTable.$(".ipSelect").prop("checked", true);
      } else {
        // $(".ipSelect").prop("checked", false);
        //datatable has to be initialized to a variable
        var myTable = $("#dataTables-table").dataTable();
        //checkboxes should have a general class to traverse
        myTable.$(".ipSelect").prop("checked", false);
      }
    }
  }

  search(status) {
    let data = this.state.dataSource;
    data = data.filter((d) => {
      return status === d.status;
    });
    this._setTableData(data);
  }

  _setTableData = async (data) => {
    var table;
    var l = [];
    var status;
    var permission = this.props.permission;
    var has_action =
      permission.isView === 1 || permission.isEdit === 1 ? true : false;
    var has_select = permission.isSelect === 1 ? true : false;
    for (var i = 0; i < data.length; i++) {
      const index = i;

      // await fetch(main_url + 'confirmation/detailCheckPerson/' + data[i].branch_id).then(response => {
      //     return response.json();
      // }).then(res => { tempArray = res })
      let result = data[i];
      let obj = [];
      obj = {
        no: i + 1,
        select: false,
        employee_id: data[i].code ? data[i].code : "",
        employee_name: data[i].fullname ? data[i].fullname : "",
        position: data[i].designations ? data[i].designations : "-",
        career_level: data[i].career_level ? data[i].career_level : "-",
        career_sub_level: data[i].career_sub_level
          ? data[i].career_sub_level
          : "-",
        department: data[i].deptname ? data[i].deptname : "-",
        branch: data[i].location_master_name
          ? data[i].location_master_name
          : "-",
        region: data[i].state_name ? data[i].state_name : "-",
        employee_date: data[i].employee_date
          ? moment(data[i].employee_date).format("DD-MM-YYYY")
          : "-",
        promotion_date: data[i].last_promotion_date
          ? moment(data[i].last_promotion_date).format("DD-MM-YYYY")
          : "-",
        //added by STHA
        current_level_effective_date: data[i].current_level_effective_date
          ? moment(data[i].current_level_effective_date).format("DD-MM-YYYY")
          : "-",
        //added by STHA
        current_sub_level_effective_date: data[i]
          .current_sub_level_effective_date
          ? moment(data[i].current_sub_level_effective_date).format(
              "DD-MM-YYYY"
            )
          : "-",
        date: moment(result.createdAt).format("DD-MM-YYYY"),
        service_year: data[i].service_year ? data[i].service_year : "-",
        current_level_service_year: data[i].current_level_service_year
          ? data[i].current_level_service_year
          : "",
        current_sub_level_service_year: data[i].current_sub_level_service_year
          ? data[i].current_sub_level_service_year
          : "",
        leave: data[i].leave ? data[i].leave : "-",
        extension:
          data[i].extension == true || data[i].leave == true
            ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView"><span id="view" class="hidden">' +
              JSON.stringify(result) +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
            : "-",
        status: data[i].status,

        // checkPerson: `<div id ='toCheckPerson' ><select id='dropdownid' on>` +
        //     '<option value="Hello"> Please choose </option>' +
        //     tempArray.map((v, i) => (
        //         `<option value='${v.user_id}' id=${v.user_id}>${v.fullname}</option>`
        //     )) +
        //     '</select></div>'
      };
      if (has_select) {
        obj.select =
          permission.isSelect === 1
            ? `<div style="alignItems:center" id="toSelect" class="select-btn"  ><input class="ipSelect" type="checkbox" /><span id="select" class="hidden" >` +
              JSON.stringify(result) +
              "</span>  </div>"
            : ""; //'<div style="margin-right:0px;height:20px;width:20px;border:1px solid red" class="btn" id="toSelect" ><i className="fas fa-address-card" style="color:red"></i><span id="view" class="hidden" >' + JSON.stringify(result) + '</span>  </div>' : '';
      }
      // if (has_action) {
      //     if (result.status !== 3) {
      //         obj.action = permission.isView === 1 ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' + JSON.stringify(result) + '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>' : '';
      //         obj.action += permission.isEdit === 1 || (result.status == 5 && data[i].createdBy == this.state.user_id) ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' + JSON.stringify(result) + '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>' : '';
      //     } else {
      //         obj.action = permission.isView === 1 ?
      //             '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' + JSON.stringify(result) + '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>' : '';

      //         if (result.print === 1) {
      //             obj.action +=
      //                 '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
      //                 JSON.stringify(result) +
      //                 '</span>  <i className="fa fa-cogs"></i>&nbsp;Printed</button>';
      //         } else {
      //             obj.action +=
      //                 '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
      //                 JSON.stringify(result) +
      //                 '</span>  <i className="fa fa-cogs"></i>&nbsp;Print</button>';
      //         }
      //     }
      // }
      // obj.checkPerson = `<div><Select options={[]} value={0} class="react-select-container checkValidate" classNamePrefix="react-select"/></div>`,
      l.push(obj);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }

    var column = [
      { title: "No", data: "no" },
      { title: "Employee Id", data: "employee_id" },
      { title: "Name", data: "employee_name" },
      { title: "Designation", data: "position" },
      { title: "Level", data: "career_level" },
      { title: "Sub Level", data: "career_sub_level" },
      // { title: 'Check Person', data: 'checkPerson' },
      { title: "Department", data: "department" },
      { title: "Branch", data: "branch" },
      { title: "Region", data: "region" },
      { title: "Last Promotion Date", data: "promotion_date" },
      //added by STHA
      {
        title: "Current Level Effective Date",
        data: "current_level_effective_date",
      },
      //added by STHA
      {
        title: "Current Sub Level Effective Date",
        data: "current_sub_level_effective_date",
      },
      { title: "Employed Date", data: "employee_date" },
      { title: "Service Year", data: "service_year" },
      {
        title: "Service Year in Current Level",
        data: "current_level_service_year",
      },
      {
        title: "Service Year in Current Sub Level",
        data: "current_sub_level_service_year",
      },
      // { title: "Leave", data: "leave" },
      { title: "Extension", data: "extension" },

      // { title: "Status", data: "status" }
    ];

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }
    if (has_select) {
      column.splice(1, 0, { title: "Select", data: "select" });
    }

    var isCheckAllCheckBox = this.props.checkboxAll;

    table = $("#dataTables-table").DataTable({
      // columnDefs: [
      //     {
      //       targets: 5,
      //       createdCell: function (td) {
      //         $(td).css('background-color', "red")
      //       }
      //     }
      //   ],
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      pageLength: 50,
      paging: true,
      buttons: true,
      dom: "Bfrtip",
      buttons: [
        //     'copy', 'csv',
        "excel",
        //  , 'pdf'
      ],
      buttons: [
        // 'copy',
        // {
        //         extend: 'csvHtml5',
        //         title: 'Child Benefit',
        // },
        {
          extend: "excelHtml5",
          title: "Confirmation Prepare List",
        },
        // {
        //     extend: 'pdfHtml5',
        //     title: 'Child Benefit',
        // }
      ],
      data: l,
      columns: column,
      createdRow: function (row, data, td, index) {
        //If leave extension
        if (data.leave === true && data.status == 5) {
          $(row).css("background-color", "Orange");
        }
        //If supervisor extension || (data.extension != '-' && data.leave == '-')
        if (data.leave == "-" && data.status == 5) {
          $(row).css("background-color", "#ed5565");
          $(row).css("color", "white");
        }

        //If leave exist
        if (data.leave === true && data.status != 5) {
          $(row).css("background-color", "Yellow");
        }
      },
      // drawCallback: function (settings) {
      //     console.log("Here is draw call back");
      //     // $(".ipSelect").prop("checked", true);

      // },
    });
  };

  render() {
    return (
      <div>
        {/* <div className="row  white-bg dashboard-header">
                    <div className="row">
                        <div class="btn-group-g ">
                            <button type="button" class="btn label-request g" onClick={this.getRequest.bind(this)}>Request</button>
                            <button type="button" class=" btn label-check g" onClick={this.getCheck.bind(this)}>Check</button>
                            <button type="button" class="btn label-verified g" onClick={this.getVerified.bind(this)}>Verify</button>
                            <button type="button" class="btn label-approve g" onClick={this.getApprove.bind(this)}>Approve</button>
                            <button type="button" class="btn label-reject g" onClick={this.getReject.bind(this)}>Reject</button>
                        </div>
                    </div>
                </div> */}

        <table
          width="99%"
          className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
          id="dataTables-table"
        />
      </div>
    );
  }
}
